import {
  Home,
  GraduationCap,
  Stethoscope,
  Image as ImageIcon,
  Mail,
  Share2,
  Search,
  BookOpen,
  Users,
  UserCog,
  Calendar,
  Briefcase,
  FileText,
  Building2,
  Layers,
  Crown,
  Handshake,
  ShieldCheck
} from "lucide-react";





export const menuItems = [
  {
    title: "Dashboard",
    url: "/dashboard",
    icon: Home
  },
  {
    title: "Events",
    url: "/events",
    icon: Calendar
  },
  {
    title: "Courses",
    url: "/courses",
    icon: BookOpen
  },
  {
    title: "Careers",
    url: "/career",
    icon: Briefcase
  },
  {
    title: "Career Applications",
    url: "/career-applications",
    icon: FileText
  },


  {
    title: "Departments",
    url: "/departments",
    icon: Building2
  },
  {
    title: "Sub department",
    url: "/categories",
    icon: Layers
  },
  {
    title: "NMC Pro-forma",
    url: "/nmc-proforma",
    icon: FileText
  },
  {
    title: "Gov Approvals",
    url: "/gov-approvals",
    icon: ShieldCheck
  },
  {
    title: "Committees",
    url: "/committees",
    icon: Users
  },
  {
    title: "Publications",
    url: "/publications",
    icon: BookOpen
  },
  {
    title: "CEO",
    url: "/ceo",
    icon: Crown
  },
  {
    title: "Dean",
    url: "/dean",
    icon: Handshake
  },
  {
    title: "Medical Superintendent",
    url: "/medical-superintendent",
    icon: Building2
  },
  {
    title: "Dysm",
    url: "/dysm",
    icon: Building2
  },
  {
    title: "Professor",
    url: "/professors",
    icon: GraduationCap
  },
  
  {
    title: "Gallery",
    url: "/gallery",
    icon: ImageIcon
  },
  {
    title: "Contacts",
    url: "/contacts",
    icon: Mail
  },
  {
    title: "Organization Profile",
    url: "/social-links",
    icon: Share2
  },
  {
    title: "Doctors",
    url: "/doctors",
    icon: Stethoscope
  },
  {
    title: "Trustees",
    url: "/trusty",
    icon: Users
  },
  {
    title: "Managing Trustees",
    url: "/managing-trustees",
    icon: UserCog
  },
  {
    title: "SEO Metadata",
    url: "/metadata",
    icon: Search
  }
];
